export default __webpack_public_path__ + "static/media/coins2.fe569a9e.mp3";